module.exports = __webpack_public_path__ + "img/jm.0dfc0416.svg";